<template>
  <dialogModule width="500px" top="15" :title="$t('payment.qrCodeCollection')" v-if="payVisible" :closeOnPressEscape="false" :dialogVisible="payVisible" @close="close">
    <span slot="close" class="el-icon-close cursor" @click="close"></span>
    <div slot="content" class="pay-content">
      <section class="pay-main">
        <p class="pay-text">{{$t('payment.initiateTransactionForEachCollection')}}</p>
        <div class="row align-center space-around money-item">
          <div class="item">
            <div>473,600</div>
            <span>{{$t('payment.totalAmount')}}</span>
          </div>
          <div class="item">
            <div>473,600</div>
            <span>{{$t('payment.receivedAmount')}}</span>
          </div>
        </div>
        <div class="pay-list">
          <div class="pay-item" v-for="(item, index) in 3" :key="index">
            <div class="title">{{$t('payment.initiateTransactionForEachCollection')}}</div>
            <div class="card row align-center space-between">
              <div class="card-left">
                <span>待发起</span>
                <div>{{$t('payment.paymentAmount')}}：1000</div>
              </div>
              <div class="card-right" @click="payLoading = true">{{$t('payment.initiateTransaction')}}</div>
            </div>
          </div>
        </div>
        <div class="end-btn row align-center space-center" @click="close">结束收款</div>
      </section>
      <section class="other-dialog row align-center space-center" v-if="payLoading">
        <div class="pay-waiting">
          <template v-if="1===1">
            <div class="icon el-icon-loading" style="color: #077cf2;"></div>
            <div class="content">交易已发起，等待金额到账</div>
          </template>
          <template v-if="1===2">
            <div class="icon el-icon-circle-check" style="color: #3fa46e;"></div>
            <div class="content">交易成功</div>
          </template>
          <template v-if="1===3">
            <div class="icon el-icon-circle-close" style="color: #f8475f;"></div>
            <div class="content">交易失败</div>
          </template>
          <div class="btn" @click="payLoading = false">取消收款</div>
        </div>
      </section>
    </div>
  </dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue"
export default {
  components: {
    dialogModule
  },
  data() {
    return {
      payVisible: true,
      payLoading: false,
    }
  },
  methods: {
    close(){
      this.payVisible = false
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.pay-content{
  .pay-main{
    padding-bottom: 20px;
    .pay-text{
      color: #000;
      text-align: center;
      margin: 20px 50px 30px;
    }
    .money-item{
      text-align: center;
      margin-bottom: 20px;
      .item{
        div{
          color: #000;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .pay-list{
      .pay-item{
        margin: 0 10px 20px;
        .title{
          color: #000;
          margin-bottom: 5px;
        }
        .card{
          padding: 10px;
          border-radius: 4px;
          border: 1px solid #eee;
          .card-left{
            span{
              font-size: 13px;
              padding: 0 10px;
              border-radius: 2px;
              border: 1px solid #eee;
            }
            div{
              margin-top: 5px;
            }
          }
          .card-right{
            color: #fff;
            cursor: pointer;
            padding: 4px 10px;
            border-radius: 4px;
            background: #ffa940;
          }
        }
      }
    }
    .end-btn{
      color: #fff;
      width: 200px;
      padding: 10px;
      cursor: pointer;
      font-size: 16px;
      border-radius: 4px;
      background: #0B83F3;
      margin: 50px auto 20px;
    }
  }
  .other-dialog{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    .pay-waiting{
      width: 400px;
      background: #fff;
      text-align: center;
      border-radius: 4px;
      padding: 30px 0;
      .icon{
        font-size: 30px;
      }
      .content{
        color: #000;
        margin: 30px auto;
      }
      .btn{
        color: #fff;
        margin: auto;
        width: 220px;
        cursor: pointer;
        line-height: 38px;
        border-radius: 4px;
        background: #0B83F3;
      }
    }
  }
}
</style>